<template>
  <v-checkbox
    :class="compClass"
    :label="label"
    :value="checkValue"
    v-model="elValue"
    :disabled="disabled"
    :readonly="readonly"
    v-validate="validateRules"
    :data-vv-name="validateName"
    :error-messages="errorMessages"
    :data-vv-validate-on="'change'"
    hide-details="auto"
  >
    <template slot="label">
      <template v-if="$slots.label">
        <slot name="label" :class="labelClass"></slot>
      </template>
      <template v-else>
        <span :class="labelClass">{{ label }}</span>
        <template v-if="supLabel">
          <sup class="sup-label">{{ supLabel }}</sup>
        </template>
      </template>
      <el-tooltip v-if="tooltip" :tooltip="tooltip" />
      <div class="ml-4" v-if="afterLabel">{{ afterLabel }}</div>
    </template>
  </v-checkbox>
</template>

<script>
export default {
  name: 'ElCheckbox',
  props: {
    classP: String,
    label: String,
    checkValue: [Object, Boolean, String, Number],
    value: [Object, Boolean, String, Array],
    supLabel: String,
    tooltip: String,
    disabled: Boolean,
    readonly: Boolean,
    labelGrey: Boolean,
    required: Boolean,
    silent: { type: Boolean, default: false },
    need: Boolean,
    inline: { type: Boolean, default: false },
    block: { type: Boolean, default: false },
    afterLabel: { type: String, default: null },
    validateKey: String,
  },
  inject: {
    $validator: '$validator',
  },
  computed: {
    elValue: {
      get() {
        return this.value
      },
      set(elValue) {
        this.$emit('input', elValue)
      },
    },
    requiredClass() {
      return (this.required || this.need) && !this.readonly && !this.silent
        ? 'required-input'
        : ''
    },
    isInline() {
      return this.inline || true
    },
    isBlock() {
      return this.block
    },
    compClass() {
      return `${this.classP} ${this.requiredClass} ${
        this.isInline && !this.isBlock ? 'inline' : ''
      }`
    },
    validateName() {
      return (
        this.validateKey ??
        (this.label && this.label.length > 0 ? this.label : 'checkbox')
      )
    },
    validateMessages() {
      return {
        field: this.$t('Laukas privalomas'),
      }
    },
    validateValue() {
      return { value: null }
    },
    validateRules() {
      let rule = ''
      if (this.required) {
        rule = this.checkValue ? 'required' : 'max:4'
      }
      return rule
    },
    errorMessages() {
      const messages = this.errors.collect(this.validateName)
      if (messages.length > 0) {
        const key = Object.keys(this.validateMessages).find(item =>
          messages[0].includes(item)
        )
        return this.validateMessages[key]
      } else {
        return ''
      }
    },
    labelClass() {
      return this.labelGrey ? 'label-grey' : ''
    },
  },
}
</script>

<style lang="scss" scoped>
@import '../../assets/scss/elementsTheme.scss';
$errorHigh: #f11a1a;

.inline {
  display: inline-block;
}
.sup-label {
  padding-left: 5px;
  font-size: 90%;
  color: $errorHigh;
}
.label-grey {
  color: rgba(0, 0, 0, 0.38);
}
</style>
